import React, { Component, Fragment } from "react";
import { Button } from "zina-dogi-react";
import DatePicker from "react-datepicker";
import swal from "sweetalert";
import { service as cpoService } from "../redux";
import { utils } from "~/utils";
import "./item_list_detail.scss";

export default class ItemListDetail extends Component {
    static header = () => (
        <nav className="navbar">
            <span className="navbar-brand h4">Basic Information</span>
        </nav>
    );

    constructor(props) {
        super(props);
        this.state = {
            delivery_date: props.item && props.item.extra_fields ? props.item.extra_fields.delivery_date : null,
            gross_value: "0.00",
            saveDisabled: false
        };
    }

    render() {
        const { className, item, onCancel } = this.props;
        const isEditable = !item;
        return (
            <div {...{ className: className + " item_list_detail" }}>
                <div className="content">
                    <div className="row">
                        <div className="col">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col">Code</th>
                                        <td>
                                            {item && !isEditable && item.item}
                                            {isEditable && <sub>This field will be generated automatically</sub>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Customer Material Number</th>
                                        <td>
                                            {item && !isEditable && item.code}
                                            {isEditable && (
                                                <input
                                                    id="code"
                                                    className="form-control"
                                                    type="text"
                                                    defaultValue={item && item.code}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Description</th>
                                        <td>
                                            {item &&
                                                !isEditable &&
                                                item.description &&
                                                item.description.split("\n").map((item, key) => {
                                                    return (
                                                        <Fragment key={`item_description_${key}`}>
                                                            {item}
                                                            <br />
                                                        </Fragment>
                                                    );
                                                })}
                                            {isEditable && (
                                                <input
                                                    id="description"
                                                    className="form-control"
                                                    type="text"
                                                    defaultValue={item && item.description}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Quantity</th>
                                        <td>
                                            {item && !isEditable && item.quantity}
                                            {isEditable && (
                                                <input
                                                    id="quantity"
                                                    className="form-control"
                                                    type="number"
                                                    onKeyPress={utils.blockLettersInputNumber}
                                                    defaultValue={item && item.quantity}
                                                    onChange={this.updateTotal}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="col">CPO Date</th>
                                        <td>
                                            {item &&
                                                !isEditable &&
                                                item.extra_fields &&
                                                utils.renderDate(item && item.extra_fields.delivery_date)}
                                            {isEditable && (
                                                <DatePicker
                                                    id="delivery_date"
                                                    dateFormat="dd/MM/yyyy"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    selected={
                                                        this.state.delivery_date
                                                            ? new Date(this.state.delivery_date)
                                                            : null
                                                    }
                                                    onChange={delivery_date => this.setState({ delivery_date })}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Unit Price</th>
                                        <td>
                                            {item && !isEditable && item.value_on_cpo}
                                            {isEditable && (
                                                <input
                                                    id="value_on_cpo"
                                                    className="form-control"
                                                    type="number"
                                                    onKeyPress={utils.blockLettersInputNumber}
                                                    onChange={this.updateTotal}
                                                    defaultValue={item && item.value_on_cpo}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Total Value</th>
                                        <td>
                                            {item && item.gross_value}
                                            {!item && isEditable && parseFloat(this.state.gross_value).toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Quantity Spent External</th>
                                        <td>
                                            <input
                                                id="quantity_spent_external"
                                                className="form-control"
                                                onKeyPress={utils.blockLettersInputNumber}
                                                defaultValue={
                                                    item &&
                                                    item.extra_fields &&
                                                    item.extra_fields.quantity_spent_external
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Quantity Contract Number</th>
                                        <td>
                                            <input
                                                id="quantity_contract_number"
                                                className="form-control"
                                                defaultValue={item && item.quantity_contract_number}
                                            />
                                        </td>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                    <div className="row controls">
                        {item && (
                            <Button
                                color="danger"
                                type="reset"
                                icon="times-circle"
                                disabled={item && item.cancelled}
                                onClick={onCancel}
                            >
                                Cancel
                            </Button>
                        )}
                        {isEditable && !item && (
                            <Button
                                color="success"
                                icon="save"
                                onClick={this.saveItem}
                                disabled={this.state.saveDisabled}
                            >
                                Save Changes
                            </Button>
                        )}
                        {item && (
                            <Button color="primary" icon="save" onClick={this.updateItem}>
                                Save as partial
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    getFormData = () => {
        const code = this.getValue("#code");
        const description = this.getValue("#description");
        const quantity_contract_number = this.getValue("#quantity_contract_number");
        const quantity_spent_external = parseInt(this.getValue("#quantity_spent_external"), 0);
        const quantity = this.getValue("#quantity") ? parseInt(this.getValue("#quantity")) : 0;
        console.log("this.state.delivery_date: ", this.state.delivery_date);
        let delivery_date = "";
        try {
            delivery_date = this.state.delivery_date ? this.state.delivery_date.toISOString().split("T", 1)[0] : null;
        } catch (e) {
            delivery_date = this.state.delivery_date ? this.state.delivery_date.split("T", 1)[0] : null;
        }
        const value_on_cpo = this.getValue("#value_on_cpo") ? parseInt(this.getValue("#value_on_cpo")) : 0;
        const gross_value = parseFloat(this.state.gross_value);
        return {
            item: 1,
            code,
            description,
            quantity,
            delivery_date,
            value_on_cpo,
            gross_value,
            type: "foc",
            quantity_spent_external,
            quantity_contract_number
        };
    };

    getValue = (field, value = "") => {
        const input = document.querySelector(field);
        return input ? input.value : value;
    };

    updateTotal = () => {
        const quantity = document.querySelector("#quantity").value
            ? parseInt(document.querySelector("#quantity").value)
            : 0;
        const value_on_cpo = document.querySelector("#value_on_cpo").value
            ? parseInt(document.querySelector("#value_on_cpo").value)
            : 0;
        this.setState({ gross_value: parseFloat(quantity) * parseFloat(value_on_cpo) });
    };

    saveItem = () => {
        const data = this.getFormData();
        this.setState({ saveDisabled: true });

        cpoService
            .createItem_foc(this.props.cpoID, data)
            .then(() => {
                swal({
                    title: "Successfully saved!",
                    icon: "success",
                    timer: 3000,
                    button: true
                });
                this.setState({ saveDisabled: false });
            })
            .catch(error => {
                if (error.response) {
                    const status = error.response.status;
                    if (status === 400) {
                        const keys = Object.keys(error.response.data)
                            .join(", ")
                            .replace("value_on_cpo", "unit price")
                            .replace("code", "customer material number");
                        swal({
                            title: "Warning ...",
                            text: `The fields ${keys} are required`,
                            icon: "warning",
                            button: true
                        });
                        this.setState({ saveDisabled: false });
                    }
                }
            });
    };

    updateItem = () => {
        const data_form = this.getFormData();
        const data = {
            type: "partial",
            quantity_spent_external: data_form.quantity_spent_external,
            quantity_contract_number: data_form.quantity_contract_number
        };
        cpoService
            .updateItem_foc(this.props.cpoID, this.props.itemID, data)
            .then(() => {
                swal({
                    title: "Successfully saved!",
                    icon: "success",
                    timer: 3000,
                    button: true
                });
            })
            .catch(error => {
                if (error.response) {
                    swal({
                        title: "Warning ...",
                        text: error.length ? error.join("\n") : utils.computeError(error),
                        icon: "warning",
                        button: true
                    });
                    this.setState({ saveDisabled: false });
                }
            });
    };
}
